import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Div from "../../../widget/common/ui/Div";
import BranchGroupsList from "./widget/BranchGroupsList";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import Center from "../../../widget/common/ui/Center";
import BranchLogoName from "../../../widget/screens/home/BranchLogoName";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import Loader from "../../../widget/common/ui/Loader";
import {
  HomeContextImport,
  HomeContextProvider,
} from "../../../provider/home/HomeContextProvider";
import StorageKeys from "../../../const/StorageKeys";
import {
  BranchGroupsContextImport,
  BranchGroupsContextProvider,
} from "../../../provider/branch/branch_groups/BranchGroupsContextProvider";
import { SearchGroupList } from "../../../model/branch/BranchGroupsModel";
import SearchInput from "../../../widget/common/form/SearchInput";
import CacheStorage from "../../../service/storage/CacheStorage";

const BranchDeptChatsContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;
  return isModal ? (
    <HomeContextProvider>
      <BranchGroupsContextProvider>
        <BranchDeptChatsMainContent type={type} isModal={isModal} />
      </BranchGroupsContextProvider>
    </HomeContextProvider>
  ) : (
    <BranchDeptChatsMainContent type={type} isModal={isModal} />
  );
};
export default BranchDeptChatsContent;

const BranchDeptChatsMainContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  const { getBranchDetail, branchDetail } = HomeContextImport();
  const {
    branchGroupsInit,
    branchGroupList,
    handleOnChange,
    clearSearch,
    onClickGroup,
    searchValue,
    showSearch,
  } = BranchGroupsContextImport();

  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [groupList, setGroupList] = useState<Array<SearchGroupList> | null>(
    null
  );

  const initData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    if (
      UtilityHelper.isEmpty(branchNameSession) ||
      UtilityHelper.isEmpty(branchLogoSession)
    ) {
      getBranchDetail();
    } else {
      setBranchName(branchNameSession);
      setBranchLogo(branchLogoSession);
    }
  };

  useEffect(() => {
    initData();
    branchGroupsInit();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setGroupList(branchGroupList);
  }, [branchGroupList]);

  useEffect(() => {
    if (branchDetail != null) {
      setBranchName(branchDetail?.title!);
      setBranchLogo(branchDetail?.branch_logo_url!);
    }
  }, [branchDetail]);

  return (
    <Div className={`${!isModal && "pt-lg-4 pb-5  h-100"}`}>
      {UtilityHelper.isNotEmpty(branchName) && !isModal && showSearch && (
        <>
          <SearchInput
            name="search-branch-group"
            placeHolder="search"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
            listLogic={true}
          />
        </>
      )}
      <>
        {UtilityHelper.isEmpty(branchName) ? (
          <Center className="h-100">{Loader.normal()}</Center>
        ) : (
          !isModal && (
            <>
              <BranchLogoName name={branchName} logo={branchLogo} type={type} />
              <SpacingHeight value={40} />
            </>
          )
        )}
      </>

      {UtilityHelper.isNotEmpty(branchName) && (
        <BranchGroupsList
          groupList={groupList}
          type={type}
          onClickGroup={onClickGroup}
        />
      )}
    </Div>
  );
};
